import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path d="M8 0a8 8 0 110 16A8 8 0 018 0zM5.297 4.889a.545.545 0 00-.22.93L7.312 7.97l-2.237 2.153a.545.545 0 10.757.785l2.25-2.182 2.07 2.153a.545.545 0 10.785-.756L8.855 7.942l2.083-2.182a.545.545 0 00-.014-.698.545.545 0 00-.771 0l-2.07 2.153-2.25-2.182a.545.545 0 00-.536-.144z" /></svg>);